import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { Title } from '@angular/platform-browser';

import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService, PromptingService } from 'src/app/shared/services';
import {
  MailServiceStatus,
  WebsiteSenderMailConfiguration,
} from '../../../../portal.model';
import { SharedPortalViewService } from '../../../shared-portal-view.service';

import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectWebsiteSenderMailConfig } from 'src/app/shared/store/_features/website/website.selector';
import { environment } from 'src/environments/environment';

export enum PortalNavigatorEnum {
  site_settings,
  pages,
  site_apperances,
}

export enum PagesFilterNavigatorEnum {
  all,
  published,
  draft,
}

@Component({
  selector: 'app-portal-sending-mail',
  templateUrl: './portal-sending-mail.component.html',
  styleUrls: ['./portal-sending-mail.component.css'],
  animations: [],
})
export class PortalSendingMailComponent implements OnInit {
  loaded: boolean = false;
  senderEmailConfig: WebsiteSenderMailConfiguration;

  mailServiceStatus: MailServiceStatus = MailServiceStatus.not_configured;
  userMailOptionsSize: number;
  userMailOptions: any;

  subscriptions: Subscription[] = [];
  constructor(
    private route: Router,

    private api: ApiService,

    public sharedPortalViewService: SharedPortalViewService,
    public authenticationService: AuthenticationService,
    private title: Title,
    private store: Store,
    private prompting: PromptingService,
  ) {
    this.subscriptions.push(
      this.store
        .select(selectWebsiteSenderMailConfig)
        .subscribe((value: WebsiteSenderMailConfiguration) => {
          if (value && value.fromEmail) {
            this.senderEmailConfig = value;
          } else {
            const website = this.sharedPortalViewService.currentWebsite.website;
            // Fallback default
            this.senderEmailConfig = {
              fromName: website.identity.title,
              fromEmail: {
                username: website.domains?.subdomain?.info?.name || 'default',
                domain: environment.hubDomain,
              },
              replyEmail: null,
            };
          }

          this.loaded = true;
        }),
    );
  }

  async ngOnInit() {
    // await this.getPortalMailingServiceStatus();
    this.title.setTitle(
      this.sharedPortalViewService.currentWebsite.website.label +
        ' > ' +
        'Mailing Settings',
    );
  }

  async setDomainMailingService() {
    if (this.mailServiceStatus == MailServiceStatus.not_configured) {
      this.route.navigateByUrl('profile/mailing');
    } else {
      this.prompting.success('All done!', '', 'md');
      let mailingEmail = '';
      // .queue([
      //   {
      //     html:
      //       'Choose an outgoing email for this Domain.<br>This is the email that your subscribers<br>will see in the FROM field <div class="input-group mt-3"><select style="height: 3.2em;" id="mailingEmail" class="form-control" placeholder="Username" aria-describedby="basic-addon2"><option value="noreply">noreply</option><option value="newsletter">newsletter</option><option value="subscribe">subscribe</option><option value="marketing">marketing</option></select><div class="input-group-append"><span class="input-group-text" id="basic-addon2">' +
      //       '@' +
      //       this.sharedPortalViewService.currentWebsite.website.siteUrl.replace(
      //         'www.',
      //         ''
      //       ) +
      //       '</span></div>',
      //     preConfirm: () => {
      //       mailingEmail =
      //         (document.getElementById('mailingEmail') as HTMLInputElement)
      //           .value +
      //         '@' +
      //         this.sharedPortalViewService.currentWebsite.website.siteUrl.replace(
      //           'www.',
      //           ''
      //         );
      //     },
      //   },
      //   {
      //     html: 'Pick a SMTP Account to use for this Domain<br>You can Configure additional accounts under <a href="profile/mailing">SMTP Settings</a>',
      //     input: 'select',
      //     inputOptions: this.userMailOptions,
      //     allowOutsideClick: false,
      //     inputAttributes: {
      //       style:
      //         'height: 2.7em;border-radius: 5px;border: 1px solid #ced4da;',
      //       autocapitalize: 'off',
      //     },
      //     confirmButtonText: 'Proceed',
      //     showLoaderOnConfirm: true,
      //     preConfirm: (mailingService) => {
      //       return this.api
      //         .updatePortalMail(
      //           +this.sharedPortalViewService.currentWebsite.id,
      //           +mailingService,
      //           mailingEmail,
      //           this.handleError
      //         )
      //         .toPromise()
      //         .then((response) => {
      //           this.mailServiceStatus = MailServiceStatus.pending;
      //           Swal.fire({
      //             icon: 'success',
      //             title: 'All done!',
      //             confirmButtonText: 'OK!',
      //           });
      //         })
      //         .catch((error) => {
      //           Swal.showValidationMessage(`Request failed: ${error}`);
      //         });
      //     },
      //   },
      // ]);
    }
  }

  // async getPortalMailingServiceStatus() {
  //   await this.getMailingData();

  //   if (this.sharedPortalViewService.currentWebsite.website.isFree) {
  //   } else {
  //     if (
  //       this.sharedPortalViewService.currentWebsite.website.isLinkedWithEmailService &&
  //       this.sharedPortalViewService.currentWebsite.website.isVerified &&
  //       this.userMailOptionsSize > 0
  //     ) {
  //       this.mailServiceStatus = MailServiceStatus.activated;
  //     } else if (
  //       this.sharedPortalViewService.currentWebsite.website.isLinkedWithEmailService &&
  //       !this.sharedPortalViewService.currentWebsite.website.isVerified &&
  //       this.userMailOptionsSize > 0
  //     ) {
  //       this.mailServiceStatus = MailServiceStatus.pending;
  //     } else if (
  //       !this.sharedPortalViewService.currentWebsite.website.isLinkedWithEmailService &&
  //       !this.sharedPortalViewService.currentWebsite.website.isVerified &&
  //       this.userMailOptionsSize > 0
  //     ) {
  //       this.mailServiceStatus = MailServiceStatus.configured;
  //     } else {
  //       this.mailServiceStatus = MailServiceStatus.not_configured;
  //     }
  //   }
  // }

  restoreCopyuserurl(objectID: string) {
    const copyBut = document.getElementById(objectID);
    // copyBut.setAttribute('style', 'background: transparent');
    copyBut.classList.value = '';
    copyBut.innerText = '';
  }
}
